import React from "react";
import { Button, Form, TextArea } from "../../../primary";
import { SAVE_BTN } from "../../../../constants";
import { allowEnterData } from "../../../../utils/patientsHelper";
import style from "./assessmentNotes.module.scss";
import { PERMISSIONS } from "../../../../constants/permissions";

export const NoteForm = ({ register, handleSubmit, doSubmit, reset, loading }) => (
  <div>
    <div className="pt-2 pb-2">
      <span className={style.notes_title}>Notes:</span> <span className={style.notes_sub_title}>(Optional)</span>
    </div>

    <Form onSubmit={handleSubmit(doSubmit)} requiredPermission={PERMISSIONS.NOTES}>
      <TextArea
        classes={{ inputClassName: `${style.textarea_box} w-100 mb-2` }}
        rows={3}
        id="notesField"
        name="notes"
        placeholder="Add notes here"
        validator={register()}
        onKeyDown={(e) => allowEnterData(e)}
      />

      <div className="d-flex justify-content-end w-100">
        <Button type="submit" id="updateNotes" classes={{ className: `btn p-1 ${style.btn_primary} ${style.d_flex}` }} disabled={loading} >
          {loading && <div className={style.spinner}></div>} {SAVE_BTN}
        </Button>
        <Button type="button" value="Clear" id="updateCancel" classes={{ className: `btn p-1 ${style.btn_scondary}` }} onClick={() => reset()} />
      </div>
    </Form>
  </div>
);
